import { render, staticRenderFns } from "./AssistantStore.vue?vue&type=template&id=30fc7996&scoped=true"
import script from "./AssistantStore.vue?vue&type=script&lang=js"
export * from "./AssistantStore.vue?vue&type=script&lang=js"
import style0 from "./AssistantStore.vue?vue&type=style&index=0&id=30fc7996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc7996",
  null
  
)

export default component.exports